import { type ReactNode, useEffect } from 'react';
import { Provider } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';

import NotificationsContainer from '../components/order/ErrorNotifications/Notifications';
import HeadScripts from './parts/HeadScripts';
import StepsSwitch from '@/components/new-order/StepsSwitch';
import ErrorBoundary from '@/components/error/ErrorBoundary';
import LocalizationProvider from '@/components/new-order/lang/LocalizationProvider';

import { store, useAppDispatch } from '@/store/new-order';
import { stripePromise as stripe } from '@/utils/stripe/newOrderSubmitAdapter';
import { rootElementOptions } from '@/utils/stripe/fieldComponentOptions';
import { fetchAPIData } from '@/store/new-order/actions/fetchAPIData';
import { setExcludeWeeklyPlans } from '@/store/featureFlagsSlice';

const PageWrapper = ({ children }: { children: ReactNode }) => (
  <>
    <HeadScripts />
    <ErrorBoundary>
      <LocalizationProvider>
        <Provider store={store}>
          <Elements stripe={stripe} options={rootElementOptions}>
            {children}
          </Elements>
        </Provider>
      </LocalizationProvider>
    </ErrorBoundary>
  </>
);

interface NewOrderProps {
  excludeWeeklyPlans?: boolean;
}

// separating wrapper, so we can use dispatch here
const NewOrderContent = ({ excludeWeeklyPlans = false }: NewOrderProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setExcludeWeeklyPlans(excludeWeeklyPlans));
    void dispatch(fetchAPIData());
  }, []);

  return (
    <PageWrapper>
      <StepsSwitch />

      <NotificationsContainer />
    </PageWrapper>
  );
};

const NewOrder = (props: NewOrderProps) => (
  <PageWrapper>
    <NewOrderContent {...props} />
  </PageWrapper>
);

export default NewOrder;
